<template lang="pug">
  #fans.view( v-show='favs.length' )
    fav-card.customers(
      v-for='item in favs'
      :key='item.id'
      :fav='item'
      :biz='biz'
      :user='user'
      :account='account'
      :filters='filters'
    )
</template>

<script>
  import FavCard from '@/components/cards/fav'
  import { db } from '@/main'

  export default {
    name: 'fans.view',

    components: {
      FavCard
    },

    props: {
      items: { type: Array },
      biz: { type: Object },
      user: { type: Object },
      account: { type: Object },
      filters: { type: Array }
    },

    data() {
      return {
        favs: [],
      }
    },

    firestore() {
      return {
        favs: {
          ref: db.collection( 'favorites' ).where( 'business_id', '==', this.biz.id ),
        }
      }
    },

    // computed: {
    //   filtered() {
    //     // return this.items.filter( c => this.favs.map( f => f.account_id ).includes( c.account_id ) )
    //     // return this.favs.map( f => f.account )
    //     return this.favs
    //   }
    // }
  }
</script>